var exports = {
  "kL": "xf0b3b88a--f1418e--container",
  "ne": "xf0b3b88a--f1418e--controls",
  "kG": "xf0b3b88a--f1418e--controls-counter",
  "hS": "xf0b3b88a--f1418e--controls-full-height",
  "fM": "xf0b3b88a--f1418e--controls-prev",
  "d5": "xf0b3b88a--f1418e--controls-next",
};

module.exports = exports;
